module.exports = __webpack_public_path__ + "img/trigma-logo.3a7501d4.svg";